/* eslint-disable */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { report } from '@/api';
import './style.less';

const ReadingReport = ({ match, history }) => {
  const [reportData, setReportData] = useState(null);
  const [new_attempt,setNewAttempt]=useState(null); 
  const { params } = match;
  const getReport = async () => {
    const data = await report.list(params.id, params.attempt);
    setReportData(data.data.read);
    setNewAttempt(data.data.new_attempt);
  };

  useEffect(() => {
    getReport();
  }, []);

  const returnScores = (type, num) => {
    const items = [];
    for (let i = 0; i < num; i += 1) {
      if (type === 'golder') {
        items.push(<div key={`diamond${i}`} className="finish" />);
      } else {
        items.push(<div key={`diamond${i}`} className="unfinish" />);
      }
    }
    return items;
  };

  const handleReading = () => history.push(`/reading/${params.id}/${params.attempt}/${params.stage}/${params.stageId}`);
  const handleDoExercises = () => history.push(`/exercises/${params.id}/${params.attempt}/${params.stage}/${params.stageId}`);
  const handleReadingShare = () => history.push(`/reading_share/${params.id}/${params.attempt}/${params.stage}/${params.stageId}/${new_attempt}`);
  return (
    <div className="reading-report">
      <div className="reading-report-wrapper">
        <div className="reading-report-professor" />
        <div className="reading-report-diamonds">
          {reportData && returnScores('golder', reportData.golderDiamonds)}
          {reportData && returnScores('empty', reportData.emptyDiamonds)}
        </div>
        <div className="reading-report-share-btn" onClick={handleReadingShare} />
        <div className="reading-report-txt">合成整本书录音分享</div>
        <div className="exercises-btn" onClick={handleDoExercises}>Do Exercises</div>
      </div>
      <div className="reading-report-btn">
        <div className="reading-report-prev" onClick={handleReading} />
        <div className="reading-report-next" onClick={handleDoExercises} />
      </div>
    </div>
  );
};

ReadingReport.propTypes = {
  match: PropTypes.object,
  history: PropTypes.object.isRequired,
};

export default withRouter(ReadingReport);
